import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/sftp/upload")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/sftp/upload", replace: true });
    },
});
